module Meevo.Plugins.Register {
    export class DrawerManagerSection extends Meevo.Plugins.Register.RegisterSectionBase{
       
//        public registerService: Meevo.Plugins.Register.IRegisterDataService;

        public data: any;
        
        constructor(registerContext: Meevo.Plugins.Register.RegisterContext,
            protected modalService: Meevo.Components.Modal.IModalService,
            private $mdDialog: ng.material.IDialogService) {

            super(RegisterSectionTypeEnum.Drawer, registerContext, "drawerManager",Register.RegisterSectionCatTypeEnum.Other);
            
        }

        closeModal = () => {
            this.$mdDialog.cancel();
        }


        public receiptRequest = () => {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/register/drawerManager/receipt.template.html",
                controller: "meevo.plugins.register.DrawerManagerController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    item: null
                }
            }

            this.modalService.showCustom(options).then((result) => {

            });
        }
        public depositRequest = () => {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/register/drawerManager/deposit.template.html",
                controller: "meevo.plugins.register.DrawerManagerController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    item: null
                }
            }

            this.modalService.showCustom(options).then((result) => {

            });
        } 
    }
   
   
}